import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AnalyticsService } from 'src/app/common/services/analytics.service';
import { ModalService } from 'src/app/shared/modals/modal.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { environment } from 'src/environments/environment';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const $: any;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const bootstrap: any;
@Component({
  selector: 'app-stepper-recommendation',
  templateUrl: './stepper-recommendation.component.html',
  imports: [CommonModule, FormsModule, SharedModule, TranslateModule],
  styleUrl: './stepper-recommendation.component.scss'
})
export class StepperRecommendationComponent  {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  recommendation: any;
  otherOptions = [];
    
  public programPrices = environment.programPrices;
  public TSA_LOGIN_URL = environment.tsaLoginURL;

  sentriInfo = {
    recommendedText: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.SH.REASON',
    programName: 'SENTRI',
    code: 'SH',
    card: {
      imageSrc: 'assets/images/logos/logo-sentri.png',
      iconAlt: 'IMAGE_ALT.SENTRI_LOGO',
      headerPrice: {
        cost: this.programPrices.SH,
        costInfo: ['HOME.FOR_5_YEARS', 'HOME.MINORS_FREE']
      },
      title: 'HOME.SH_CARD_FOR',
      description: [
        'HOME.SH_STREAMLINED_FOR',
      ],
      includesPreCheck: 'maybe',
      learnMoreLink: '',
      getStartedLink: ''
    },
    note: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.SH.NOTE',
    noteHeader: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.SH.NOTE_HEADER',
    benefits: [
      {
        icon: '<i class="uswds-icon icon-car"></i>',
        description: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.SH.BENEFITS.PROCESSING_LANES'
      },
      {
        icon: '<i class="uswds-icon icon-car"></i>',
        description: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.SH.BENEFITS.NEXUS'
      },
      {
        icon: '<i class="uswds-icon icon-plane"></i>',
        description: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.SH.BENEFITS.GLOBAL_ENTRY'
      },
    ]
  };

  globalEntryInfo = {
    recommendedText: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.UP.REASON',
    programName: 'Global Entry',
    code: 'UP',
    card: {
      imageSrc: 'assets/images/logos/logo-global-entry.png',
      iconAlt: 'IMAGE_ALT.GLOBAL_ENTRY_LOGO',
      headerPrice: {
        cost: this.programPrices.UP,
        costInfo: ['HOME.FOR_5_YEARS', 'HOME.MINORS_FREE']
      },
      title: 'HOME.UP_CARD_FOR',
      description: [
        'HOME.UP_STREAMLINED_FOR',
      ],
      includesPreCheck: 'yes',
      learnMoreLink: ''
    },
    note: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.UP.NOTE',
    noteHeader: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.UP.NOTE_HEADER',
    benefits: [
      {
        icon: '<i class="uswds-icon icon-clock"></i>',
        description: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.UP.BENEFITS.WAIT_TIME'
      },
      {
        icon: '<i class="uswds-icon icon-plane"></i>',
        description: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.UP.BENEFITS.AIRPORTS'
      },
      {
        icon: '<img class="benefit-image" src="assets/images/logos/tsaprecheck-official.png" alt="TSA Precheck">',
        description: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.UP.BENEFITS.PRECHECK'
      },
      {
        icon: '<i class="uswds-icon icon-car"></i>',
        description: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.UP.BENEFITS.BORDERS'
      },
    ]
  };

  nexusInfo = {
    recommendedText: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.NH.REASON',
    programName: 'NEXUS',
    code: 'NH',
    card: {
      imageSrc: 'assets/images/logos/logo-nexus.png',
      iconAlt: 'IMAGE_ALT.GLOBAL_ENTRY_LOGO',
      headerPrice: {
        cost: this.programPrices.NH,
        costInfo: ['HOME.FOR_5_YEARS']
      },
      title: 'HOME.NH_CARD_FOR',
      description: [
        'HOME.NH_STREAMLINED_FOR',
      ],
      includesPreCheck: 'maybe',
      learnMoreLink: ''
    },
    note: '',
    benefits: [
      {
        icon: '<i class="uswds-icon icon-car"></i>',
        description: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.NH.BENEFITS.LANES'
      },
      {
        icon: '<i class="uswds-icon icon-plane"></i>',
        description: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.NH.BENEFITS.GLOBAL_ENTRY'
      },
      {
        icon: '<i class="uswds-icon icon-ship"></i>',
        description: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.NH.BENEFITS.SEA'
      },
      {
        icon: '<image class="benefit-image" src="assets/images/logos/tsaprecheck-official.png" alt="TSA Precheck">',
        description: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.NH.BENEFITS.PRECHECK'
      },
    ]
  };

  fastInfo = {
    recommendedText: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.FAST.REASON',
    programName: 'FAST',
    code: 'FAST',
    card: {
      imageSrc: 'assets/images/logos/logo-us-mexico-fast.jpg',
      iconAlt: 'IMAGE_ALT.FAST_LOGO',
      headerPrice: {
        cost: this.programPrices.FAST,
        costInfo: ['HOME.FOR_5_YEARS']
      },
      title: 'HOME.FAST_CARD_FOR',
      description: [
        'HOME.FAST_STREAMLINED_FOR'
      ],
      learnMoreLink: ''
    },
    note: '',
    benefits: [
      {
        icon: '<i class="uswds-icon icon-clock"></i>',
        description: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.FAST.BENEFITS.PROCESSING_TIME'
      },
      {
        icon: '<i class="fa-solid fa-check"></i>',
        description: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.FAST.BENEFITS.LANES'
      },
    ]
  };

  tsaPreCheckInfo = {
    recommendedText: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.TSA.REASON',
    programName: 'TSA PreCheck®',
    code: 'TSA',
    card: {
      imageSrc: 'assets/images/logos/tsaprecheck-official.png',
      iconAlt: 'IMAGE_ALT.FAST_LOGO',
      headerPrice: {
        cost: this.programPrices.TSA,
        costInfo: ['HOME.FOR_5_YEARS']
      },
      title: 'HOME.TSA_CARD_FOR',
      description: [
        'HOME.TSA_STREAMLINED_FOR',
      ],
      learnMoreLink: ''
    },
    note: '',
    benefits: [
      {
        icon: '<i class="uswds-icon icon-clock"></i>',
        description: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.TSA.BENEFITS.LANES'
      }
    ]
  };

  constructor(private analyticsService: AnalyticsService, private modalService: ModalService) {}
  
  logIn(code?: string): void {
    this.logGetStartedProgram(code);
    this.closeModal();
    
    $('#security-warn').modal('show');
  }

  setBestMatch(bestMatch: string, citizenship?: string) {
    this.recommendation = null;
    switch (bestMatch) {
      case 'up':
        this.recommendation = this.globalEntryInfo;
        this.setGlobalEntryNote(citizenship);
        break;
      case 'nh':
        this.recommendation = this.nexusInfo;
        break;
      case 'sh':
        this.recommendation = this.sentriInfo;
        break;
      case 'fast':
        this.recommendation = this.fastInfo;
        break;
      case 'tsa':
        this.recommendation = this.tsaPreCheckInfo;
        break;          
    }
  }

  setOtherOptions(otherMatches: string[]) {
    this.otherOptions = [];
    otherMatches.forEach(om => {

      switch (om) {
        case 'up':
          this.otherOptions.push(this.globalEntryInfo);
          break;
        case 'nh':
          this.otherOptions.push(this.nexusInfo);
          break;
        case 'sh':
          this.otherOptions.push(this.sentriInfo);
          break;
        case 'fast':
          this.otherOptions.push(this.fastInfo);
          break;
        case 'tsa':
          this.otherOptions.push(this.tsaPreCheckInfo);
          break;          
      }
    });
  }

  private setGlobalEntryNote(citizenship: string) {
    if (citizenship === 'none') {
      this.recommendation.note = 'HOME.COMPARISON_STEPPER.RECOMMENDATION.UP.NOTE';
    }
  }

  public closeModal() {
    bootstrap.Modal.getInstance(document.getElementById('comparison-wizard')).hide();
  }

  public logGetStartedProgram(programName: string) {
    if (programName) {
      this.analyticsService.logGetStarted(programName).subscribe();
    }
  }

  public showConsiderTSAModal(): void {
    this.closeModal();
    this.modalService.considerTSA()
    .then(res =>  {
      if (res) { this.execContinueWithUP(); }
    });
  }

  public execContinueWithUP(): void {
    this.logIn('UP');
  }
}
